import { DataModel } from "@toolpad/core/Crud";

import { IHomeChargerDto } from "../generated/api-client";
import { nameof } from "../utils/object.utils";
import MagicCrud, { MagicCrudFields } from "../components/MagicCrud";

type HomeChargerDtoDataModel = IHomeChargerDto & DataModel;

export default function HomeChargersPage() {
  const columns: MagicCrudFields<IHomeChargerDto>[] = [
    {
      field: nameof<IHomeChargerDto>("id"),
      type: "number",
      extraType: "guid",
    },
    {
      field: nameof<IHomeChargerDto>("serialNumber"),
      type: "string",
    },
    {
      field: nameof<IHomeChargerDto>("createDate"),
      type: "dateTime",
      notInEditMode: true,
      notInCreateMode: true,
    },
    {
      field: nameof<IHomeChargerDto>("updateDate"),
      type: "dateTime",
      notInEditMode: true,
      notInCreateMode: true,
    },
  ];

  return (
    <MagicCrud<HomeChargerDtoDataModel>
      name="homeCharger"
      apiUrl="home-chargers"
      columns={columns}
      appUrl="/home-chargers"
    />
  );
}
